import { render } from "./QuienesSomos.vue?vue&type=template&id=425dcfe4&scoped=true&ts=true"
import script from "./QuienesSomos.vue?vue&type=script&lang=ts"
export * from "./QuienesSomos.vue?vue&type=script&lang=ts"

import "./QuienesSomos.vue?vue&type=style&index=0&id=425dcfe4&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Dell\\latam\\latamlogistichn\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-425dcfe4"]])

export default __exports__